import React from 'react';
import { connect } from 'react-redux'
import { inlineSettings, tabSettings } from '../../../../components/TinyMCE/tinyconfig';
import { Editor } from "@tinymce/tinymce-react";
import ArchiveContainer from '../../../../file/containers/ArchiveContainer';
import { sourceTypes } from '../../../../constants/cms/sourceType';
import { emailActions } from '../../../../store/actions/cms/email/email.action';
import LinkManager from '../../../../navigation/LinkManager/LinkManager';
import { templateHelper } from '../../../areas/template/helpers/templateHelper';
import { TinyMCE } from "tinymce";
const getGlobal = function () { return (typeof window !== 'undefined' ? window : global); };
const setTinymce = function () {
    var global = getGlobal();
    if (global && !global.tinymce)
        global.tinymce = TinyMCE;
};

class TinyEditor extends React.Component {
    constructor(props) {
        super(props);
        this.toggleArchive = this.toggleArchive.bind(this);
        this.onInit = this.onInit.bind(this);
        this.handleKeyUp = this.handleKeyUp.bind(this);
        this.onArchiveUseSelect = this.onArchiveUseSelect.bind(this);
        this.state = {
            editor: {},
            cycleEditor: false,
            archiveOpen: false,
            active: false,
            linkHelperOpen: false,
            selectedLink: null
        }
        setTinymce();
    }
    componentDidUpdate(prevProps) {
        if (this.props.env === sourceTypes.FORM && prevProps.form.currentPage !== this.props.form.currentPage) {
            this.setState({ cycleEditor: true })
        }
        if (this.state.cycleEditor === true) {
            this.setState({ cycleEditor: false })
        }
    }

    onInit(editor, languageCode) {
        this.setState({ editor }, () => {
        });
        const { env, dispatch, element, email } = this.props;
        if (element && env === sourceTypes.EMAIL) {
            const newElement = Object.assign({}, element);
            newElement.style.elementProps.editor = this.state.editor;
            dispatch(emailActions.updateEmailElement(newElement, newElement.id, false, email.inherit))
        }
    };
    toggleArchive() {
        this.setState({ archiveOpen: !this.state.archiveOpen })
    }
    handleKeyUp = (event, languageCode) => {
        var content = this.state.editor.getContent();
        if (content !== this.props.value) {
            if (this.props.globalFormat === true) {
                this.props.onChange(null, content, this.props.path);
            }
            else if (this.props.slimFormat === true) {
                this.props.onChange(content, this.props.path);
            } else {
                this.props.onChange(content);
            }
        }

    };
    formatImage(id) {
        var content = this.state.editor.getContent();
        this.props.onChange(content);
    }
    onArchiveUseSelect(url) {
        var image = new Image;
        image.crossOrigin = "anonymous"; /* THIS WILL MAKE THE IMAGE CROSS-ORIGIN */
        image.src = url;
        let content = this.state.editor.insertContent(`<img src="${image.src}"  alt="_blank" height="auto" width="100%" /> `);
        content = this.state.editor.getContent();
        this.props.onChange(content);
    }
    onLinkSelect = (obj) => {
        const { linkColor = undefined } = this.props;
        let content = null;
        if (linkColor) {
            let lc = '';
            if (linkColor.includes('rgb')) {
                lc = templateHelper.convertRgbStringToHex(linkColor)
            }

            content = this.state.editor.insertContent(`<a href=${obj.currentLink} target=${obj.target}  >
            <span style="color: ${lc};">
                <font color="${lc}"> ${obj.displayText}</font>
            </span> 
        </a> `);
        }
        else {
            content = this.state.editor.insertContent(`<a href=${obj.currentLink} target=${obj.target}  >
             ${obj.displayText}
        </a> `);
        }

        content = this.state.editor.getContent();
    }
    toggleLinkHelper = () => {

        this.setState({ linkHelperOpen: !this.state.linkHelperOpen })
    }
    render() {
        const { style, value, onInit, onChange, cms, inline = true, height, env, selectedElement, contentId = null, element = null } = this.props;

        return (
            <React.Fragment>
                {!this.state.cycleEditor ? <Editor
                    value={value}
                    onInit={(event, editor) =>
                        this.onInit(editor, cms && cms.languageCode)
                    }
                    onFocus={() => this.setState({ active: true })}
                    disabled={!this.props.editMode}
                    init={inline ? {
                        ...inlineSettings, content_style: style, width: '100%', height: '100%', setup: (editor) => {
                            editor.ui.registry.addButton('archive', {
                                icon: 'image',
                                image: 'image',
                                onAction: () =>
                                    this.toggleArchive()
                            });
                            editor.ui.registry.addButton('anchor', {
                                icon: 'link',
                                image: 'link',
                                onAction: () => {
                                    const selectedLink = editor.selection.getNode();
                                    if (selectedLink && selectedLink.localName === "a") {
                                        this.setState({
                                            selectedLink: {
                                                target: selectedLink.target,
                                                link: selectedLink.href,
                                                name: selectedLink.innerHTML
                                            }
                                        })
                                    }
                                    else {
                                        const range = editor.selection.getRng();
                                        if (range) {
                                            this.setState({
                                                selectedLink: {
                                                    target: "_blank",
                                                    link: "",
                                                    name: range.startContainer.data ? range.startContainer.data.substring(range.startOffset, range.endOffset) : " ",
                                                }
                                            })
                                        }
                                    }
                                    this.toggleLinkHelper()
                                }
                            });
                        },
                    } : {
                        ...tabSettings, content_style: style, width: '100%', height: height, setup: (editor) => {
                            editor.ui.registry.addButton('archive', {
                                icon: 'image',
                                image: 'image',
                                onAction: () =>
                                    this.toggleArchive()
                            })
                        }
                    }
                    }
                    onEditorChange={e => this.handleKeyUp(e, cms && cms.languageCode)}
                /> : null}
                <LinkManager
                    setLink={this.onLinkSelect}
                    isOpen={this.state.linkHelperOpen}
                    toggle={this.toggleLinkHelper}
                    selectedLink={this.state.selectedLink} />
                {this.state.archiveOpen ? <ArchiveContainer
                    isOpen={this.state.archiveOpen}
                    onUseSelected={this.onArchiveUseSelect}
                    showLaunchBtn={false}
                    toggle={this.toggleArchive} /> : null}
            </React.Fragment>
        )
    }
}

function mapStateToProps(state) {
    let selectedElement = null;
    let env = null;
    if (state.cms.enviroment === sourceTypes.TEMPLATE) {
        selectedElement = state.template.selectedElement;
        env = sourceTypes.TEMPLATE
    }
    if (state.cms.enviroment === sourceTypes.PAGE) {
        selectedElement = state.page.selectedElement;
        env = sourceTypes.PAGE
    }
    if (state.cms.enviroment === sourceTypes.FORM) {
        selectedElement = state.form.selectedElement;
        env = sourceTypes.FORM
    }
    if (state.cms.enviroment === sourceTypes.EMAIL) {
        selectedElement = state.email.selectedElement;
        env = sourceTypes.EMAIL
    }
    return {
        alert: state.alert,
        form: state.form,
        cms: state.cms,
        selectedElement,
        template: state.template,
        language: state.language,
        page: state.page,
        email: state.email,
        env
    };
}
export default connect(mapStateToProps)(TinyEditor);
